<template>
  <hm-container>
    <div slot="header">
      <el-radio-group @change="swithcTab" v-model="queryType" size="small">
        <el-radio-button label="user">用户标签</el-radio-button>
        <el-radio-button label="goods">商品标签</el-radio-button>
        <!-- <el-radio-button label="recycleBin">标签回收站</el-radio-button> -->
      </el-radio-group>
    </div>
    <div
      v-if="queryType !== 'recycleBin'"
      class="table-panel flex flex-between"
    >
      <div class="mr20">
        <el-button @click="setTag('add')" type="primary" size="small"
          >创建标签</el-button
        >
      </div>
      <div class="mr20">
        <el-button type="primary" size="small" @click="showCopyVisble" v-if="tagRowArr.length > 0"
          >批量复制</el-button
        >
      </div>
      <div class="flex-1 flex flex-wrap flex-end">
        <el-select
          style="width: 200px"
          size="small"
          clearable
          placeholder="请选择运行状态"
          v-model="searchConditions.enabledState"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(v, i) in runStateList"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select>
        <el-select
          style="width: 200px"
          size="small"
          clearable
          placeholder="请选择审批状态"
          v-model="searchConditions.auditState"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(v, i) in auditStatusList"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select>
        <!-- <el-select
          style="width: 200px"
          size="small"
          clearable
          placeholder="请选择创建方"
          v-model="searchConditions.createByPlatform"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(v, i) in createByList"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select> -->
        <el-select
          style="width: 200px"
          size="small"
          clearable
          placeholder="请选择最后计算状态"
          v-model="searchConditions.calcStatus"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(v, i) in finalCalcStatusList"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select>
        <el-input
          size="small"
          class="mr10"
          v-model="searchConditions.tagName"
          placeholder="请输入标签名称"
        ></el-input>
        <el-input
          size="small"
          class="mr10"
          v-model="searchConditions.createBy"
          placeholder="请输入创建人员"
        ></el-input>
        <el-button size="small" type="primary" @click="paging(1)"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table-panel flex flex-end" v-else>
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择标签分类"
        v-model="searchConditions.tagClassification"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in tagClassificationList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        class="mr10"
        v-model="searchConditions.tagName"
        placeholder="请输入标签名称"
      ></el-input>
      <el-button size="small" type="primary" @click="paging(1)">查询</el-button>
    </div>
    <div
      class="base-tag-container flex"
      :class="{ normal: queryType !== 'recycleBin' }"
    >
      <div v-if="queryType !== 'recycleBin'" class="menu">
        <el-tree
          :data="tagAttributeList"
          :props="defaultProps"
          :expand-on-click-node="false"
          :highlight-current="true"
          current-node-key="currentNode"
          node-key="id"
          default-expand-all
          @node-click="handleNodeClick"
        >
          <template v-slot="{ node, data }">
            <span
              class="tree-label"
              :class="{ system: data.createBy === 'System' }"
            >
              <span
                class="hmicon icon-xitongshezhi2x system-icon"
                v-if="data.createBy === 'System'"
              ></span>
              {{ node.label }}
            </span>
          </template>
        </el-tree>
        <!-- <el-menu
          @select="slectedMenu"
          :default-openeds="['0']"
          mode="vertical"
          class="tag-menu"
        >
          <el-submenu index="0" v-for="(v, i) in tagAttributeList"
              :key="i"
              :index="'0-' + (i + 1)">
            <template slot="title">
              <label class="primary">用户画像</label>
            </template>
            {{ v.catName }}
            <el-menu-item
              
              ></el-menu-item
            >
          </el-submenu>
        </el-menu> -->
      </div>
      <div class="table flex-1">
        <el-table
          v-if="queryType !== 'recycleBin'"
          stripe
          border
          ref="table"
          :data="list"
          size="small"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            prop="tagName"
            label="标签名称"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tagRemark"
            label="描述"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="calcCount"
            :label="queryType === 'user' ? '覆盖人数' : '覆盖商品'"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="storeName"
            label="所属商户"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="运行状态"
            header-align="center"
            align="center"
          >
            <template v-slot="scope">
              <span class="success" v-if="scope.row.enabledState === 'yes'"
                >运行中</span
              >
              <span class="gray" v-else>未运行</span>
            </template>
          </el-table-column>
          <el-table-column
            label="审核状态"
            header-align="center"
            align="center"
          >
            <template v-slot="scope">
              <span class="success" v-if="scope.row.auditState === 'yes'"
                >已审批</span
              >
              <span class="gray" v-else>待审批</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTypeFormat"
            label="创建方式"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createBy"
            label="创建人员"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="toDetails(scope.row)"
              >
                查看详情
              </el-button>

              <el-button
                type="text"
                size="small"
                :class="scope.row.enabledState === 'yes' ? 'danger' : 'success'"
                @click="closeTag(scope.row)"
              >
                <span v-if="scope.row.enabledState === 'yes'">停止</span>
                <span v-else>开启</span>
              </el-button>

              <el-button
                type="text"
                size="small"
                class="blue"
                @click="setTag('edit', scope.row)"
              >
                编辑
              </el-button>
              <!-- <el-button
                type="text"
                size="small"
                class="blue"
                @click="setTag('copy', scope.row)"
              >
                复制
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else stripe border ref="table" :data="list" size="small">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            prop="tagName"
            label="标签名称"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tagRemark"
            label="描述"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tagName"
            label="标签分类"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tagName"
            label="备注"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="状态" header-align="center" align="center">
            <template v-slot="scope">
              <span class="success" v-if="scope.row.enabledState === 'yes'"
                >运行中</span
              >
              <span class="gray" v-else>未运行</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="toDetails(scope.row)"
              >
                查看详情
              </el-button>

              <el-button
                type="text"
                size="small"
                class="blue"
                @click="setTag('edit', scope.row)"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                size="small"
                class="danger"
                @click="showDialogForm(scope.row)"
              >
                删除并清空
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      width="500px"
      title="删除并清空"
      :visible.sync="dialogFormVisible"
    >
      <div class="text-center">
        <span class="alert hmicon icon-tishi"></span>
        <div class="tips">您确定删除并清空么?</div>
        <div>将会删除此标签，并在所有用户中清除此标签</div>
      </div>
      <div class="textarea-wrapper">
        <el-input
          type="textarea"
          rows="5"
          :autosize="false"
          show-word-limit
          maxlength="100"
          v-model="removeRemark"
          placeholder="请输入删除理由"
        />
      </div>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="removeTag"
          >删除并清空</el-button
        >
        <el-button size="small" @click="dialogFormVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="通过哪种方式创建标签"
      :visible.sync="createTagDialogVisible"
      width="800px"
    >
      <div class="ways" v-for="(v, i) in ways" :key="i">
        <div class="type-name">{{ v.typeName }}</div>
        <div class="children flex flex-wrap">
          <div
            class="child pointer flex flex-wrap flex-between"
            @click="selectWay(item)"
            v-for="(item, index) in v.children"
            :key="index"
          >
            <img :src="item.logo" alt="logo" />
            <div class="flex-1">
              <div class="title">{{ item.name }}</div>
              <div class="remark">
                {{ queryType === "user" ? item.remark : item.remarkForGoods }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <create-tag
      :queryType="queryType"
      v-if="drawerVisible"
      :drawerVisible="drawerVisible"
      :currentWay="currentWay"
      :draggableShow="true"
      :tagCat="searchConditions.tagCat"
      :tagDetails="tagDetails"
      :queryTagDetailsId="queryTagDetailsId"
      @closeDrawer="closeDrawer"
      @createSucc="createSucc"
    ></create-tag>
    <el-dialog
      :with-header="false"
      :wrapperClosable="false"
      size="800px"
      class="create-tag-drawer"
      :visible.sync="copyVisble"
      :append-to-body="true"
    >
      <el-form
        label-width="120px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        @submit.native.prevent
      >
        <el-form-item label="复制到渠道" prop="tenantId">
          <el-select
            size="small"
            placeholder="请选择渠道"
            v-model="ruleForm.tenantId"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(v, i) in storeCodeList"
              :key="i"
              :label="v.storeName"
              :value="v.storeCode"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideCopyVisble">取 消</el-button>
        <el-button type="primary" @click="copyTags">确 定</el-button>
      </span>
    </el-dialog>
  </hm-container>
</template>

<script>
import createTag from "@/views/portraitLabelMgt/modules/createTag";
import { post } from "@/utils/utils";
import { Form } from 'element-ui';

export default {
  components: {
    createTag,
  },
  data() {
    return {
      copyVisble: false,
      ruleForm: {
        tenantId: "42010216070190",
      },
      rules: {
        tenantId: {
          required: true,
          message: "请选择渠道",
          trigger: "change",
        },
      },
      tagRowArr:[],
      storeCodeList: [],
      queryTagDetailsId: "",
      removeRemark: "",
      currentRow: {},
      tagDetails: null,
      drawerVisible: false,
      createTagDialogVisible: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      queryType: "user",
      currentWay: {},
      defaultProps: {
        label: "catName",
      },
      ways: [
        {
          typeName: "界面创建",
          children: [
            {
              logo: "https://imgcdn.hemiao100.com/tag/SketchPng2cca1007d042004073140338e02ec8809e16b1fc1101e3399d448b6f9adcd84b.png",
              name: "多属性标签",
              type: "view",
              wayName: "multiAttr",
              remark:
                "自定义标签多个属性及规则,例如性别标签,属性为男、女、未知",
              remarkForGoods:
                "自定义标签多个属性及规则,例如适合季节标签，属性为春季、秋季、全季",
            },
            // {
            //   logo:
            //     "https://imgcdn.hemiao100.com/tag/SketchPng28940252615c83dc6c12f32ba2efb3978399b3698ae414ffe9b2f67747212d64.png",
            //   name: "基础指标值",
            //   wayName: "basicIndex",
            //   type: "view",
            //   remark: "将用户完成事件的次数等指标的计算结果作为指标的值"
            // },
            // {
            //   logo:
            //     "https://imgcdn.hemiao100.com/tag/SketchPngeec367b1fac238bdabd19c5c5f6ccf8242dfebc7cbfac17c48818ec3cdcfe247.png",
            //   name: "首末次特征",
            //   wayName: "characteristics",
            //   type: "view",
            //   remark:
            //     "用户首次或末次完成事件的时间，距离今日的天数或事件的属性作为标签的值"
            // },
            // {
            //   logo:
            //     "https://imgcdn.hemiao100.com/tag/SketchPngc27ba0384661dfa54038a95c861537d0df4a998f28c5878c302d01036bc6e861.png",
            //   name: "事件偏好属性",
            //   wayName: "preferenceAttr",
            //   type: "view",
            //   remark: "用户完成事件排名前几个的分组作为标签的值"
            // },
            // {
            //   logo:
            //     "https://imgcdn.hemiao100.com/tag/SketchPng1c7872541a1434aae158fcd96bf607070701fd7ce2dd3b14761e0aa532ab87f7.png",
            //   name: "行为分布结果",
            //   wayName: "behaviorDistributionResults",
            //   type: "view",
            //   remark:
            //     "将用户完成事件在指定时间段内分布的天数或小时数作为标签的值"
            // }
          ],
        },
        // {
        //   typeName: "代码创建",
        //   children: [
        //     {
        //       logo:
        //         "https://imgcdn.hemiao100.com/tag/SketchPng80123a2530a241182831f4c0addad0ebd1086fa3b60474e3ad0190e5c6bbc8d3.png",
        //       name: "SQL创建",
        //       wayName: "sql",
        //       type: "code",
        //       remark: "使用返回的SQL计算结果作为标签的值，为用户进行标记",
        //       remarkForGoods:
        //         "使用返回的SQL计算结果作为标签的值，为商品进行标记"
        //     }
        //     // {
        //     //   logo:
        //     //     "https://imgcdn.hemiao100.com/tag/SketchPng9c4340c9bed86cc0ccec5eca942de6e0d27984ce1cb93e050a0110a38075d84b.png",
        //     //   name: "算法创建",
        //     //   wayName: "code",
        //     //   type: "code",
        //     //   remark: "通过算法创建标签"
        //     // }
        //   ]
        // }
      ],
      searchConditions: {
        tagCat: "",
      },
      runStateList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "运行中",
          value: "yes",
        },
        {
          name: "未运行",
          value: "no",
        },
      ],
      auditStatusList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "待审批",
          value: "no",
        },
        {
          name: "已审批",
          value: "yes",
        },
      ],
      createByList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "平台",
          value: "platform",
        },
        {
          name: "商家",
          value: "merchant",
        },
      ],
      finalCalcStatusList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "计算成功",
          value: "success",
        },
        {
          name: "计算失败",
          value: "fail",
        },
        {
          name: "等待计算",
          value: "waitCalc",
        },
      ],
      tagAttributeList: [],
      tagClassificationList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "用户标签",
          value: "user",
        },
        {
          name: "商品标签",
          value: "goods",
        },
      ],
      currentStep: 1,
      tabIndex: 1,
    };
  },
  created() {
    this.queryList();
    this.queryAllTag();
    this.queryLabelStoreCode();
  },
  methods: {
    async queryAllTag() {
      if (this.queryType === "recycleBin") return;
      const { result } = await this.$store.dispatch("queryAllTagCat", {
        queryType: this.queryType,
      });
      const list = [
        {
          catName: "全部",
          id: "001",
          children: result,
        },
      ];
      this.tagAttributeList = list;
    },
    async queryLabelStoreCode() {
      const { result } = await this.$store.dispatch("queryLabelStoreCode");
      console.log("查询标签商城", result);
      this.storeCodeList = result;
    },
    // 打开复制弹窗
    showCopyVisble() {
      this.copyVisble = true;
    },
    hideCopyVisble() {
      this.copyVisble = false;
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
    createSucc() {
      this.drawerVisible = false;
      this.paging(1);
    },
    handleNodeClick(data) {
      this.searchConditions.tagCat = data.id === "001" ? "" : data.id;
      this.paging(1);
    },
    // 选择菜单下的子选项
    slectedMenu(index) {
      const attrIndex = index.split("-")[1] - 1;
      this.searchConditions.tagCat = this.tagAttributeList[attrIndex].id;
      this.paging(1);
    },
    // 停止标签
    async closeTag(row) {
      const text = row.enabledState === "yes" ? "停止" : "开启";
      const result = await this.$confirm("确定" + text + "此标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        await this.$store.dispatch("updateTagEnableState", {
          id: row.id,
          enabledState: row.enabledState === "yes" ? "no" : "yes",
        });
        this.paging(1);
      }
    },
    // 打开设置标签弹窗
    async setTag(type, row) {
      this.type = type;
      if ((type = "copy")) {
        this.isCopy = true;
      }
      if (row) {
        this.queryTagDetailsId = row.id;
        console.log("queryType: ", this.queryTagDetailsId);

        this.currentRow = row;
        const { result } = await this.$store.dispatch("queryTagDetails", {
          id: row.id,
        });
        this.tagDetails = result;
        this.drawerVisible = true;
      } else {
        this.createTagDialogVisible = true;
        this.tagDetails = null;
      }
    },
    // 选择标签类型
    selectWay(row) {
      this.currentWay = row;
      this.createTagDialogVisible = false;
      this.drawerVisible = true;
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryTagList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        ...this.searchConditions,
        tagType: this.queryType === "recycleBin" ? undefined : this.queryType,
        delFlag: this.queryType !== "recycleBin" ? "0" : "1",
      });
      const { records, total } = result;
      this.list = records;
      this.total = total;
      this.translateCreateType();
    },
    translateCreateType() {
      this.list.forEach((v) => {
        this.ways.map((o) => {
          let row = o.children.find((child) => child.wayName === v.createType);
          if (row) {
            v.createTypeFormat = row.name;
          }
        });
      });
    },
    // 打开删除并清空弹窗
    showDialogForm(row) {
      this.currentRow = row;
      this.dialogFormVisible = true;
    },
    swithcTab() {
      this.searchConditions.tagCat = "";
      this.paging(1);
      this.queryAllTag();
    },
    // 选择多个行
    handleSelectionChange(e) {
      console.log(e);
      this.tagRowArr = e
    },
    async copyTags(){
      this.tagRowArr.forEach(el=>{
        console.log(el.id)
        this.queryCopyTags(this.ruleForm.tenantId,el.id)
      })
      this.hideCopyVisble()
      setTimeout(() => {
        this.paging(1);
        this.queryAllTag();
      }, 1000);
    },
    async queryCopyTags(fromStoreCode,tagId){
      // const res = await post({
      //   url: "/tag/tagCopy"
      // },{
      //   fromStoreCode:fromStoreCode,
      //   tagId:tagId
      // })
      await this.$store.dispatch("coptTag", {
        fromStoreCode,
        tagId
      });
    },
    // 删除标签请求
    async removeTag() {
      if (!this.removeRemark) {
        this.$message({ type: "warning", message: "请输入删除理由" });
        return;
      }
      await this.$store.dispatch("removeTag", {
        delFlag: "1",
        id: this.currentRow.id,
        removeRemark: this.removeRemark,
      });
      this.dialogFormVisible = false;
      this.paging(1);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.queryList();
    },
    toDetails(row) {
      this.$router.push({
        name: "TagDetails",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.base-tag-container {
  .is-current {
    .el-tree-node__content {
      background: transparent !important;
    }
    .tree-label {
      color: #ea3384 !important;
    }
  }
  .system-icon {
    margin-right: 5px;
  }
  .el-menu {
    border-right: none;
  }
}
</style>
<style scoped lang="scss">
.alert {
  color: #ff7f10;
  font-size: 38px;
}
.tips {
  color: #ff7f10;
  font-size: 18px;
  margin: 9px 0;
}

.textarea-wrapper {
  margin: 28px 60px 0;
  height: 132px;
}
.base-tag-container {
  &.normal {
    margin-top: 20px;
    border-top: 1px solid #f8f6f8;
    .table {
      min-width: 600px;
      padding: 20px 30px;
      border-left: 1px solid #f8f6f8;
    }
  }
  .menu {
    width: 202px;
    flex-shrink: 0;
  }
}

.ways {
  .type-name {
    margin-bottom: 20px;
  }
  .children {
    margin-bottom: 20px;
  }
  .child:nth-child(n + 1) {
    margin-right: 2%;
  }
  .child {
    flex-basis: 48%;
    height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 14px 1px #eeeeee;
    border-radius: 8px;
    padding: 28px;
    box-sizing: border-box;
    margin-bottom: 20px;
    img {
      width: 79px;
      height: 79px;
      margin-right: 18px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .remark {
      font-size: 14px;
      color: #666;
    }
  }
}

.tree-label {
  font-size: 14px;
  color: #2b2b2b;
  &.system {
    color: #999;
  }
}
</style>
